
import { useApiStore } from "@/stores/apiStore";
import { useAuthStore } from "@/stores/authStore";
import { useToastStore } from "@/stores/toastStore";
import { PropType, defineComponent } from "vue";

export default defineComponent({
	name: "imdex-hierarchy-selector",
	setup() {
		const api = useApiStore();
		const toast = useToastStore();
		const authStore = useAuthStore();

		return { api, toast, authStore };
	},
	props: {
		holeIdColumn: {
			type: String,
			default: ""
		},
		columns: {
			type: Array,
			default: () => []
		},
		hierarchySelectedColumns: {
			type: Object as PropType<string[]>,
			default: () => [] as string[]
		}
	},
	data() {
		return {
			properties: this.columns.filter((item: any) => {
				if (
					!this.hierarchySelectedColumns.includes(item.name) &&
					item.selected &&
					item.name != this.holeIdColumn
				) {
					return { name: item.name };
				}
			}) as any[],
			hierarchy: this.hierarchySelectedColumns
				.filter((item) => item !== this.holeIdColumn)
				.map((item: string) => {
					return { name: item };
				}) as any[],
			originalDragEl: null as any,
			dragEl: null as any,
			dropEl: null as any,
			dragProp: null as any,
			mousemovelistener: null as any
		};
	},
	mounted() {
		// this.properties = this.columns.filter((item:any) => {
		//     if (!this.hierarchySelectedColumns.includes(item.name)) {
		//         return { name: item.name }
		//     }
		// })
		// this.hierarchy = this.hierarchySelectedColumns.map((item: string)=>{
		//     return { name: item }
		// })
	},
	methods: {
		reset() {
			this.hierarchy = [];
			this.properties = this.columns
				.filter((col: any) => col.name != this.holeIdColumn)
				.map((item: any) => {
					return { name: item.name };
				});
			this.$emit("update:hierarchySelectedColumns", []);
		},
		dragStart(e: any, property: any) {
			const [offsetX, offsetY, x, y] = [e.offsetX, e.offsetY, e.pageX, e.pageY];
			const body = window.document.getElementsByTagName("body")[0];

			this.dragProp = property;
			this.dragEl = e.srcElement.cloneNode(true);
			this.originalDragEl = e.srcElement;
			this.originalDragEl.style.opacity = 0.5;
			const { width } = e.srcElement.getBoundingClientRect();
			body.appendChild(this.dragEl);
			this.dragEl.style.top = y - offsetY + "px";
			this.dragEl.style.width = width + "px";
			this.dragEl.style.left = x - offsetX + "px";
			this.dragEl.style.position = "fixed";
			this.dragEl.style.zIndex = 1000000;
			this.dragEl.style.boxShadow = "0px 9px 18px -9px rgba(0, 0, 0, 0.5)";

			window.addEventListener("mouseup", this.dragEnd);
			window.addEventListener(
				"mousemove",
				(this.mousemovelistener = (ev: any) => this.mouseMove(ev, offsetX, offsetY))
			);
		},
		mouseMove(e?: any, offsetX?: number, offsetY?: number) {
			const [x, y] = [e.pageX, e.pageY];
			const docs: any = window.document.elementsFromPoint(x, y) as any;
			const dropOption = docs.filter((item: HTMLElement) => {
				return item.classList.contains("drop-option");
			});
			if (dropOption.length > 0) {
				this.dropEl = dropOption[0];
				this.dropEl.classList.add("hovered");
				this.dragEl.style.opacity = 0.7;
			} else {
				if (this.dropEl != null) {
					this.dropEl.classList.remove("hovered");
				}
				this.dropEl = null;
				this.dragEl.style.opacity = 1;
			}
			if (offsetX != null && offsetY != null) {
				this.dragEl.style.top = y - offsetY + "px";
				this.dragEl.style.left = x - offsetX + "px";
			}
		},
		dragEnd() {
			this.dragEl.style.boxShadow = `0px 2px 2px rgba(0,0,0,0.3)`;
			const body = window.document.getElementsByTagName("body")[0] as any;
			if (this.dropEl == null) {
				body.removeChild(this.dragEl);
				this.originalDragEl.style.opacity = 1;
			} else {
				this.dropEl.classList.remove("hovered");
				this.properties.splice(
					this.properties.findIndex((item: any) => item.name == this.dragProp.name),
					1
				);
				this.hierarchy.push(this.dragProp);
				const stringArrayHierarchies = this.hierarchy.map((item: any) => item.name);
				this.$emit("update:hierarchySelectedColumns", stringArrayHierarchies); // rerender's the component
				body.removeChild(this.dragEl);
				this.originalDragEl.style.opacity = 1;
			}
			window.removeEventListener("mouseup", this.dragEnd);
			window.removeEventListener("mousemove", this.mousemovelistener);
		}
	}
});
